<template>
  <MultiplePieChart
    :request-status="requestStatus"
    :series="series"
    :title="title"
    :item-id="itemId"
    v-bind="$attrs"
    @reload="getData"
  />
</template>

<script>
import MultiplePieChart from '@/components/cards/models/MultiplePieChart';
import sentimentModel from '@/mixins/sentiment-model';
import channelModel from '@/mixins/channel-model';

import { mapActions } from 'vuex';
import EventBus from '@/utils/event-bus';
import { OPERATION } from '@/services/charts-service';

export default {
  name: 'DistributionMediaPieChart',
  components: {
    MultiplePieChart,
  },
  mixins: [
    sentimentModel,
    channelModel,
  ],
  props: {
    title: {
      type: String,
      required: true,
    },
    itemId: {
      type: [String, Number],
      required: true,
    },
    operation: {
      type: String,
      default: OPERATION.COUNT,
    },
  },
  data() {
    return {
      requestStatus: 'loading',
      rawSeries: [],
    };
  },
  computed: {
    series() {
      if (!this.rawSeries) {
        return [];
      }
      const medias = [];
      const sentiments = [];
      Object.entries(this.rawSeries).forEach(([key, value]) => {
        const { y } = value.reduce((total, currentValue) => {
          return { y: total.y + currentValue.y };
        });
        const channelObj = this.getChannelColorNameAndIcon(key);
        medias.push({
          name: channelObj.name,
          color: channelObj.color,
          y,
        });
        value.forEach(({ name, y }) => {
          if (y > 0) {
            sentiments.push({ name: this.getSentimentLabel(name), y, color: this.getSentimentColor(name) });
          }
        });
      });
      return [
        {
          name: this.$t('DistributionMediaPieChart.sentiment'),
          data: sentiments,
          size: '90%',
        },
        {
          name: this.$t('DistributionMediaPieChart.medias'),
          data: medias,
          size: '75%',
        },
      ];
    },
  },
  created() {
    this.getData();
  },
  methods: {
    ...mapActions('cards', [
      'getMediaService',
    ]),
    getData(options) {
      if (!options?.silentRefresh) {
        this.requestStatus = 'loading';
      }

      this.getMediaService({
        itemId: this.itemId,
        servicePath: 'getDistributionMedia',
      })
        .then(response => {
          const rawSeries = {};
          response.data.series.forEach(serie => {
            if (!rawSeries[serie[0]]) {
              rawSeries[serie[0]] = [];
            }
            rawSeries[serie[0]].push({
              name: serie[1],
              y: serie[2],
            });
          });
          Object.entries(rawSeries).forEach(([key, value]) => {
            const { y } = value.reduce((total, currentValue) => {
              return { y: total.y + currentValue.y };
            });
            if (y === 0) {
              delete rawSeries[key];
            }
          });
          this.rawSeries = rawSeries;
          this.requestStatus = 'success';

          if (options?.silentRefresh) {
            EventBus.$emit('updated', { itemId: this.itemId });
          }
        })
        .catch(error => {
          console.error(error);
          this.requestStatus = 'error';
        });
    },
  },
};
</script>
